import type { NativeRecallItem } from '../lib/nativeTurn'

function phaseLabel(phase: string): string {
  return phase === 'pre_tool' ? '工具时更新' : '提示回顾'
}

function recallDisplayText(text: string): string {
  const envelope = /\s*(?:<subcon_whisper\b[^>]*>([\s\S]*?)<\/subcon_whisper>|<letta_message\b([^>]*)>([\s\S]*?)<\/letta_message>)\s*/gy
  const parts: string[] = []
  let cursor = 0

  while (cursor < text.length) {
    envelope.lastIndex = cursor
    const match = envelope.exec(text)
    if (!match) return text

    const newWhisperBody = match[1]
    const legacyAttributes = match[2]
    const legacyBody = match[3]
    if (legacyAttributes !== undefined && !/\bfrom\s*=\s*(["'])Subconscious\1/.test(legacyAttributes)) {
      return text
    }

    parts.push((newWhisperBody ?? legacyBody ?? '').trim())
    cursor = envelope.lastIndex
  }

  return parts.length > 0 ? parts.join('\n\n') : text
}

export function NativeRecall({ items }: { items: NativeRecallItem[] }) {
  if (items.length === 0) return null
  return <div className="chat-msg thinking recall">
    <details className="msg-thinking msg-recall">
      <summary>回顾 · {items.length}</summary>
      <div className="msg-thinking-content msg-recall-content">
        {items.map((item, index) => <div className="msg-recall-entry" key={item.sequence ?? index}>
          <div className="msg-recall-phase">{phaseLabel(item.phase)}</div>
          <pre>{recallDisplayText(item.text)}</pre>
        </div>)}
      </div>
    </details>
  </div>
}
